export default __webpack_public_path__ + "0b7ea26876748523726e5c5fa03054d8.png";